/** Host responsibilities shown on New Vehicle listing and Terms (KAN-205). */

export const HOST_RESPONSIBILITIES = [
  {
    id: "roadworthy",
    title: "Keep the vehicle roadworthy",
  },
  {
    id: "clean-refuel",
    title: "Keep the vehicle clean and refuel before every trip",
  },
];

export function formatHostResponsibilityLine(item) {
  if (!item) return "";
  return item.detail ? `${item.title} — ${item.detail}` : item.title;
}
